import { render, staticRenderFns } from "./personage.vue?vue&type=template&id=5fcbb1bc&"
import script from "./personage.vue?vue&type=script&lang=js&"
export * from "./personage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports